<template>
  <div>
    <div class="filters">
      <row
        @submit="apply"
        @addChild="addChild"
        @removeChild="removeChild"
        v-for="(filter, index) in filters"
        :index="index"
        :filter="filter"
        :operators="operators"
        :columns="columns"
        :key="index"
      />
    </div>
    <a-button
      @click.prevent="apply"
      class="filters__button"
      type="primary"
      v-if="filters.length"
      >Применить фильтр</a-button
    >
     <a-button
      @click.prevent="reset"
      class="filters__button"
      v-if="appliedFilter"
      >Сбросить фильтр</a-button
    >
    <a-button
      @click.prevent="remove"
      type="danger"
      class="filters__button"
      v-if="appliedFilter && !forSearch"
      :loading="isDeleting"
      >Удалить отфильтрованные строки</a-button
    >
  </div>
</template>

<script>
import Row from './Row.vue';

export default {
  name: 'filters',
  props: ['forSearch', 'visible', 'name'],
  components: { Row },
  data() {
    return {
      filters: [],
      isDeleting: false,
      appliedFilter: '',
      operators: {
        '*=': 'содержит', '=': 'равняется', '^=': 'начинается с', '$=': 'заканчивается на', '>': 'больше', '>=': 'больше или равняется', '<': 'меньше', '<=': 'меньше или равняется', '!=': 'не равняется', IN: 'содержится в', IS: 'является',
      },
    };
  },
  computed: {
    currentEntity() {
      return this.forSearch ? this.name : this.$store.getters.currentEntity;
    },
    entities() {
      return this.$store.getters.entities;
    },
    sorting() {
      const obj = this.$store.getters.columnsSettings
        .find(v => v.entity === this.currentEntity) || {};
      return obj.sorted || [];
    },
    columns() {
      return Object.values(this.$store.getters.entities[this.currentEntity].params)
        .sort((a, b) => this.sorting.indexOf(a.name) - this.sorting.indexOf(b.name));
    },
    queryFilter() {
      return this.$route.query.filter;
    },
  },
  watch: {
    visible() {
      this.reset();
    },
    currentEntity() {
      this.reset();
    },
    appliedFilter() {
      if (this.forSearch) {
        return;
      }

      if (!this.appliedFilter) {
        this.$router.push({
          query: {},
        });
        return;
      }

      if (this.$route.query.filter !== this.appliedFilter) {
        this.$router.push({
          query: {
            filter: this.appliedFilter,
          },
        });
      }
    },
    queryFilter() {
      this.handleQuery();
    },
  },
  methods: {
    getTemplate({
      name, operator, value = '', children = [], condition = 'OR', childCondition = 'OR',
    }) {
      return {
        column: name, operator, value, children, condition, childCondition,
      };
    },
    addFilter() {
      this.filters.push(
        this.getTemplate({ name: this.columns[0].name, operator: Object.keys(this.operators)[0] }),
      );
    },
    addChild(children) {
      children.push(
        this.getTemplate({ name: this.columns[0].name, operator: Object.keys(this.operators)[0] }),
      );
    },
    removeChild(index, parent) {
      const list = parent ? parent.children : this.filters;
      list.splice(index, 1);
    },
    getFilter(filters) {
      return filters.map((filter, index) => {
        let key = `${filter.column} ${filter.operator}`;
        if (index !== 0 && !filter.children.length) {
          key = `${filter.condition} ${key}`;
        }
        const obj = {
          [key]: filter.value,
        };
        if (filter.children.length) {
          return {
            [index !== 0 ? filter.condition : '']: [obj, { [filter.childCondition]: this.getFilter(filter.children) }],
          };
        }
        return obj;
      });
    },
    apply() {
      this.appliedFilter = JSON.stringify(this.filters);
      this.$emit('change', this.getFilter(this.filters));
    },
    reset() {
      this.filters = [];
      this.appliedFilter = '';
      this.$emit('change', {});
    },
    remove() {
      // eslint-disable-next-line
      if (!confirm(`Вы действительно хотите удалить все отфильтрованные строки?`)) {
        return;
      }
      this.isDeleting = true;
      this.$api.deleteEntities({
        name: this.currentEntity,
        filter: JSON.stringify(this.getFilter(JSON.parse(this.appliedFilter))),
      })
        .then(this.reset)
        .finally(() => {
          this.isDeleting = false;
        });
    },
    handleQuery() {
      if (this.forSearch) {
        return;
      }
      const { filter } = this.$route.query;
      if (JSON.stringify(filter) === this.appliedFilter) {
        return;
      }

      try {
        this.filters = JSON.parse(decodeURIComponent(filter));
        this.apply();
      } catch {
        // eslint-disable-no-empty
      }
    },
  },
  created() {
    this.handleQuery();
  },
};
</script>

<style lang="scss">
.filter__column,
.filter__cond,
.filter__operator {
  .ant-select-selection-selected-value {
    padding-right: 5px;
  }
}
</style>

<style lang="scss" scoped>
.filters {
  &__button {
    margin-top: 8px;
    margin-right: 8px;
  }
}
</style>
